<script>
  export let idUnico = 'capa';
  import { location } from 'svelte-spa-router';
  import Router from 'svelte-spa-router';
  import conteudo from '../conteudo';
  import Container from './layout/container.svelte';
  export let content;

  const indexOfFirstSpace = content.trim().indexOf(' ');
  const charAfterSpace = content.trim().charAt(indexOfFirstSpace + 1);

  $: paginaAtual = Number($location.split('/')[1]) - 1;

  // $: indiceUnidade = paginaAtual - 1;
  $: indiceUnidade = charAfterSpace;
  // $: tituloCompleto = content.trim().substring(indexOfFirstSpace + 3);
  $: tituloCompleto = content.trim();
  $: tituloUnidade = tituloCompleto;

  let unidade = Number($location.split('/')[1]);
</script>

<div class="container" style="max-width: 40em !important;">
  {#if Number($location.split('/')[1]) === 1 || $location === '/'}
    <div class="curso-container">
      <div class="logo">
        <img src="./assets/images/identity/logo.svg" alt="" />
      </div>
      <div class="titulo-curso">
        <h2>{conteudo.curso}</h2>
        <!-- <h2>{conteudo.complemento}</h2> -->
      </div>
    </div>
    <div class="apresentacao-container">
      <div class="modulo">
        MÓDULO {conteudo.modulo}
      </div>
      <div class="titulo-modulo">
        <h2>{conteudo.titulo}</h2>
        <h2>{conteudo.paginas[0]}</h2>
      </div>
    </div>
  {:else if Number($location.split('/')[1]) === conteudo.paginas.length}
    <div class="unidade-container">
      <div class="grid">
        <h2>MÓDULO {conteudo.modulo}</h2>
        <h2 class="referencias">{conteudo.paginas[conteudo.paginas.length - 1]}</h2>
      </div>
      <div style="height: 102px;"></div>
    </div>
  {:else}
    <div class="unidade-container">
      <div class="grid">
        <h2>MÓDULO {conteudo.modulo}</h2>
        <h2>UNIDADE {paginaAtual}</h2>
      </div>
      <div class="titulo">
        {@html tituloUnidade}
      </div>
    </div>
  {/if}
</div>

<style>
  .unidade-container {
    background: url(../assets/images/identity/unidade-bkg.svg);
    display: grid;
    grid-template-columns: 1fr;
    background-size: cover;
    padding: 20px 0 30px 0;
    row-gap: 10px;
  }

  .grid {
    display: flex;
    justify-content: right;
  }

  .grid h2:nth-child(1) {
    background: var(--VERDE);
    border-radius: 30px 0 0 30px;
    padding: 10px 60px 10px 30px;
    color: var(--BRANCO);
    font-family: var(--FONT_INTER);
    font-weight: 700;
    height: fit-content;
    position: relative;
    left: 50px;
  }

  .grid h2:nth-child(2) {
    background: var(--BRANCO);
    border-radius: 50px 0 0 50px;
    padding: 25px 20px 25px 30px;
    color: var(--VERDE);
    font-family: var(--FONT_LORA);
    font-weight: 700;
    font-size: 36px;
    position: relative;
    line-height: 1;
    /* font-style: italic; */
  }

  .grid h2.referencias {
    background: var(--BRANCO);
    border-radius: 50px 0 0 50px;
    padding: 25px 20px 25px 30px;
    color: var(--VERDE);
    font-family: var(--FONT_INTER);
    font-weight: 500;
    font-size: 36px;
    position: relative;
    line-height: 1;
    font-style: italic;
  }

  .titulo {
    background: linear-gradient(to right, var(--VERDE_CLARO), var(--AMARELO));
    padding: 30px 40px 30px 20px;
    border-radius: 0 80px 80px 0;
    position: relative;
    font-family: var(--FONT_LORA);
    font-weight: 600;
    font-size: 28px;
    color: var(--BRANCO);
    width: calc(100% - 15px);
    line-height: 1.2;
  }

  .titulo::before {
    content: '';
    width: 20px;
    height: calc(100% + 20px);
    background: var(--VERDE_CLARO);
    position: absolute;
    left: -20px;
    top: 0px;
    z-index: 2;
    border-radius: 15px 0 0 15px;
  }

  .titulo::after {
    content: '';
    width: 18px;
    height: 18px;
    background: var(--VERDE_ESCURO);
    position: absolute;
    left: -19px;
    bottom: -20px;
    z-index: 3;
    border-radius: 10px 0 0 10px;
  }

  .titulo-modulo {
    background: linear-gradient(to right, var(--VERDE), var(--VERDE));
    padding: 25px 40px 25px 20px;
    border-radius: 0 60px 60px 0;
    position: relative;
    width: max-content;
    width: calc(100% - 15px);
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 10px;
  }

  .titulo-modulo::before {
    content: '';
    width: 20px;
    height: calc(100% + 20px);
    background: var(--VERDE);
    position: absolute;
    left: -20px;
    top: 0px;
    z-index: 2;
    border-radius: 15px 0 0 15px;
  }

  .titulo-modulo::after {
    content: '';
    width: 18px;
    height: 20px;
    background: var(--VERDE_ESCURO_2);
    position: absolute;
    left: -18px;
    bottom: -20px;
    z-index: 3;
    border-radius: 10px 0 0 10px;
  }

  .titulo-modulo h2:nth-child(1) {
    font-family: var(--FONT_INTER);
    font-weight: 500;
    font-size: 32px;
    color: var(--BRANCO);
  }

  .titulo-modulo h2:nth-child(2) {
    font-family: var(--FONT_INTER);
    font-weight: 500;
    font-size: 28px;
    color: var(--BRANCO);
    font-style: italic;
  }

  .apresentacao-container {
    background: url(../assets/images/identity/apresentacao-bkg.svg);
    display: grid;
    grid-template-columns: 1fr;
    background-size: cover;
    padding: 20px 0 30px 0;
    row-gap: 10px;
  }

  .curso-container {
    background: url(../assets/images/identity/curso-bkg.svg);
    display: grid;
    grid-template-columns: 1fr;
    background-size: cover;
    padding: 20px 0 30px 0;
    margin-bottom: 20px;
  }

  .logo {
    background: var(--BRANCO);
    border-radius: 50px 0 0 50px;
    padding: 20px 15px 20px 25px;
    color: var(--VERDE);
    font-family: var(--FONT_INTER);
    font-weight: 700;
    font-size: 36px;
    position: relative;
    justify-self: right;
    line-height: 1;
  }

  .logo img {
    width: 150px;
  }

  .titulo-curso {
    background: linear-gradient(to right, var(--AMARELO), var(--VERDE_CLARO));
    padding: 25px 40px 25px 15px;
    border-radius: 0 120px 120px 0;
    position: relative;
    width: max-content;
    width: calc(100% - 165px);
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 10px;
    margin-top: -40px;
  }

  .titulo-curso::before {
    content: '';
    width: 20px;
    height: calc(100% + 20px);
    background: var(--AMARELO);
    position: absolute;
    left: -20px;
    top: 0px;
    z-index: 2;
    border-radius: 15px 0 0 15px;
  }

  .titulo-curso::after {
    content: '';
    width: 18px;
    height: 20px;
    background: var(--VERDE_CLARO);
    background: #d6c32d;
    position: absolute;
    left: -18px;
    bottom: -20px;
    z-index: 3;
    border-radius: 10px 0 0 10px;
  }

  .titulo-curso h2:nth-child(1) {
    font-family: var(--FONT_INTER);
    font-weight: 500;
    font-size: 32px;
    color: var(--VERDE);
    max-width: calc(100% - 70px);
  }

  .titulo-curso h2:nth-child(2) {
    font-family: var(--FONT_INTER);
    font-weight: 400;
    font-size: 20px;
    color: var(--VERDE);
  }

  .modulo {
    background: var(--BRANCO);
    border-radius: 50px 0 0 50px;
    padding: 25px 20px 25px 30px;
    color: var(--VERDE);
    font-family: var(--FONT_INTER);
    font-weight: 700;
    font-size: 36px;
    position: relative;
    justify-self: right;
    line-height: 1;
  }

  .container {
    margin-top: 0;
  }

  @media (max-width: 767px) {
    .container {
      padding: 0;
    }
    .titulo {
      align-items: center;
      padding-left: 15px;
      padding-bottom: 40px;
      padding-top: 40px;
      padding-right: 15px;
    }
    .titulo-curso {
      width: calc(100% - 15px);
      padding: 20px 25px 15px 15px;
      border-radius: 0 90px 90px 0;
      margin-top: 0;
    }

    .titulo-curso h2:nth-child(1) {
      font-size: 24px;
    }

    .titulo-curso h2:nth-child(2) {
      font-size: 18px;
    }

    .logo img {
      width: 130px;
    }
    .curso-container {
      padding: 20px 0;
      row-gap: 10px;
    }
    .titulo-modulo {
      width: calc(100% - 15px);
      /* width: max-content; */
      padding: 20px 25px 15px 15px;
    }
    .titulo-modulo h2:nth-child(1) {
      font-size: 28px;
    }
    .titulo-modulo h2:nth-child(2) {
      font-size: 24px;
    }
    .modulo {
      font-size: 32px;
      padding: 20px 15px 15px 20px;
    }
    .apresentacao-container {
      row-gap: 10px;
      padding: 20px 0 20px 0;
    }
    .grid h2:nth-child(2) {
      font-size: 24px;
      padding: 20px 10px 15px 20px;
    }
    .grid h2:nth-child(1) {
      font-size: 22px;
      left: 50px;
      height: min-content;
      padding: 10px 60px 10px 20px;
    }
    .titulo {
      padding: 15px 20px 15px 15px;
      font-size: 24px;
    }
    .unidade-container {
      row-gap: 10px;
    }
  }
</style>
